module.exports = "/_next/static/media/89b7a1389f3495a47feaa8fc246deaa0.svg";